import type { ReactNode } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { PlayNoticeProvider } from "@/components/feature/PlayNotice";

interface PageLayoutProps {
  children: ReactNode;
  className?: string;
}

export default function PageLayout({ children, className }: PageLayoutProps) {
  return (
    <PlayNoticeProvider>
      <div className="min-h-screen flex flex-col bg-background-50">
        <Navbar />
        <main className={`flex-1 w-full ${className || ""}`}>{children}</main>
        <Footer />
      </div>
    </PlayNoticeProvider>
  );
}